/**
* Featured Products Callout JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Products Callout component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'featured-products-callout',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.fpc_slider' ).slick( {
        infinite: false,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        appendArrows: $( '#fpc_slider-nav' ),
        prevArrow: '<button><svg class="text-brand-ash icon icon-chevron-left"><use xlink:href="#icon-chevron-left"></use></svg></button>',
        nextArrow: '<button><svg class="text-brand-ash icon icon-chevron-right"><use xlink:href="#icon-chevron-right"></use></svg></button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              initialSlide: 1,
              slidesToShow: 1,
              centerMode: true,
            },
          },
        ],
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-products-callout', COMPONENT );
} )( app );
